"use client";

import styled from "styled-components";

export const CardServiceReport = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  border: 1px solid var(--border);
  border-radius: 8px;
  transition: 0.3s;
  background: var(--cardBackground, #fff);

  &:hover {
    box-shadow: var(--shadowHoverCard);
    transform: translateY(-3px);
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Employee = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const Avatar = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--softMint);
  color: var(--greenAndWhite);
  font-family: "Inter Medium";
`;

export const Name = styled.h4`
  margin: 0;
  font-family: "Inter Medium";
  font-size: 15px;
  color: var(--colorTitle);
`;

export const Small = styled.span`
  display: block;
  font-size: 13px;
  color: var(--textLight);
`;

export const Actions = styled.div`
  display: flex;
  gap: 6px;
`;

export const Body = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 18px;
  align-items: center;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Label = styled.span`
  font-size: 12px;
  color: var(--textLight);
`;

export const Value = styled.span`
  font-family: "Inter Medium";
  font-size: 15px;
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

export const TotalLabel = styled.span`
  font-size: 13px;
  color: var(--textLight);
`;

export const TotalValue = styled.span`
  font-family: "Inter Medium";
  font-size: 16px;
`;
